/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ===== EG Auto Add to Cart popup: lock the free-item frequency to the PDP selection =====
  // When a subscription is added to the cart, the EG Auto Add to Cart app opens a popup
  // (#aca-modal) where the customer picks a free item. Each item in that popup has its
  // own "subscription plan" dropdown (select.aca-variant-subscriptions). This preselects
  // the frequency the customer just chose in the Recharge widget on the product page and
  // disables the dropdown so the free item always ships on the same schedule.
  //
  // The chosen plan is captured from the product form's selling_plan input when the
  // customer adds to cart (Recharge writes it there). EG opens the popup before the
  // item reaches the cart, and every product has its own selling plan ids, so the
  // popup's options are matched by plan name. The name comes from the Recharge widget
  // config on the page, then the product's JSON, then /cart.js as a last resort.
  var EG_PLAN_SELECT = 'select.aca-variant-subscriptions';
  var EG_MODAL_SELECTOR = '#aca-modal';
  var LOCKED_SELECT_CLASS = 'aca-variant-subscriptions--locked';
  var LOCKED_WRAPPER_CLASS = 'aca-product-dropdown--frequency-locked';
  var LOCKED_TITLE = 'Matches the delivery frequency of your subscription';

  var BUNDLE_WIDGET_SELECTOR = '.gbbPbWidgetWrapper';      // Easy Bundle / Gift Box Builder
  var BUNDLE_ADD_BUTTON = '.gbbPbAddToCartBtn, .gbbPbAddToCart button';
  var BUNDLE_DEFAULT_FREQUENCY = '1 month';                // every bundle subscribes monthly

  var selectedPlan = null;     // { id: '123', name: 'Every 2 weeks' } from the last add to cart
  var cartPlanPromise = null;  // in-flight /cart.js lookup after an add
  var productPlans = {};       // product handle -> Promise<{ planId: { name, frequency } }>

  function normalizeText(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  // "Deliver every 2 weeks" / "2 week subscription" / "2-month" -> "2 week" / "2 month"
  function frequencyKey(value) {
    var match = normalizeText(value).match(/(\d+)\s*(day|week|month|year)s?\b/);
    return match ? match[1] + ' ' + match[2] : null;
  }

  // Frequency of a selling plan from its name, else from its option values
  // (Recharge plans carry an "Order Frequency and Unit" option such as "1-month").
  function planFrequency(plan) {
    if (!plan) return null;
    var key = frequencyKey(plan.name);
    if (key) return key;
    var options = plan.options || [];
    for (var i = 0; i < options.length; i++) {
      var value = options[i] && (options[i].value != null ? options[i].value : options[i]);
      key = frequencyKey(value);
      if (key) return key;
    }
    return plan.frequency || null;
  }

  function isAddToCartForm(form) {
    var action = (form.getAttribute('action') || '').split('?')[0];
    return /\/cart\/add/.test(action);
  }

  // Recharge's widget block prints its plans on the page as SubscriptionWidgetConfig.shopifyPlans.
  function planNameFromWidgetConfig(planId) {
    var config = window.SubscriptionWidgetConfig;
    var plans = config && config.shopifyPlans;
    if (!Array.isArray(plans)) return '';
    for (var i = 0; i < plans.length; i++) {
      if (plans[i] && String(plans[i].id) === planId) return String(plans[i].name || '').trim();
    }
    return '';
  }

  function productHandleForForm(form) {
    var holder = form.closest('[data-product-handle]') || form.querySelector('[data-product-handle]');
    if (holder && holder.dataset.productHandle) return holder.dataset.productHandle;
    var match = (form.getAttribute('action') || '').match(/\/products\/([^\/?#]+)/) ||
      window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? match[1] : null;
  }

  function fetchProductPlans(handle) {
    if (!handle) return Promise.resolve({});
    if (!productPlans[handle]) {
      productPlans[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function(product) {
          var plans = {};
          ((product && product.selling_plan_groups) || []).forEach(function(group) {
            (group.selling_plans || []).forEach(function(plan) {
              var entry = { name: String(plan.name || '').trim(), options: plan.options || [] };
              entry.frequency = planFrequency(entry);
              plans[String(plan.id)] = entry;
            });
          });
          return plans;
        })
        .catch(function() {
          delete productPlans[handle];
          return {};
        });
    }
    return productPlans[handle];
  }

  // Product handles worth searching for a plan id: the form's product, the page's
  // product, and any product linked from a bundle builder widget on the page.
  function candidateProductHandles(form) {
    var handles = [];
    var add = function(handle) { if (handle && handles.indexOf(handle) === -1) handles.push(handle); };
    if (form) add(productHandleForForm(form));
    var pageMatch = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (pageMatch) add(pageMatch[1]);
    document.querySelectorAll('[data-product-handle]').forEach(function(el) { add(el.dataset.productHandle); });
    document.querySelectorAll('.gbbPbWidgetWrapper a[href*="/products/"], [class*="gbbPb"] a[href*="/products/"]').forEach(function(a) {
      var match = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (match) add(match[1]);
    });
    return handles.slice(0, 8);
  }

  // Resolve a selling plan's name and frequency by id, checking the candidate
  // products one at a time until one of them carries that plan.
  function lookupPlanDetails(planId, handles) {
    var name = planNameFromWidgetConfig(planId);
    if (name) return Promise.resolve({ name: name, frequency: frequencyKey(name) });
    return handles.reduce(function(chain, handle) {
      return chain.then(function(found) {
        if (found) return found;
        return fetchProductPlans(handle).then(function(plans) { return plans[planId] || null; });
      });
    }, Promise.resolve(null));
  }

  // Best-effort plan name from the PDP widget (option text or radio label matching the id).
  function planNameFromPage(form, planId) {
    var scope = form.closest('[data-section-type]') || document;
    var candidates = scope.querySelectorAll('option[value="' + planId + '"], input[value="' + planId + '"]');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.tagName === 'OPTION') return el.text.trim();
      var label = (el.id && scope.querySelector('label[for="' + el.id + '"]')) || el.closest('label');
      if (label) return label.textContent.trim();
    }
    return '';
  }

  function sellingPlanFromForm(form) {
    var inputs = form.querySelectorAll('[name="selling_plan"], [name$="[selling_plan]"]');
    for (var i = 0; i < inputs.length; i++) {
      var value = inputs[i].disabled ? '' : String(inputs[i].value || '').trim();
      if (value) return value;
    }
    return '';
  }

  function setSelectedPlan(id, form) {
    cartPlanPromise = null;
    if (!id) {
      selectedPlan = null;
      return;
    }
    if (selectedPlan && selectedPlan.id === id) return;
    var plan = { id: id, name: planNameFromWidgetConfig(id) || (form ? planNameFromPage(form, id) : ''), frequency: null, namePromise: null };
    plan.frequency = frequencyKey(plan.name);
    if (!plan.name || !plan.frequency) {
      plan.namePromise = lookupPlanDetails(id, candidateProductHandles(form)).then(function(details) {
        if (details) {
          if (!plan.name) plan.name = details.name || '';
          plan.frequency = plan.frequency || details.frequency || frequencyKey(plan.name);
        }
        if (!plan.name && !plan.frequency && document.querySelector(BUNDLE_WIDGET_SELECTOR)) {
          plan.frequency = BUNDLE_DEFAULT_FREQUENCY;
        }
        return plan;
      });
    }
    selectedPlan = plan;
  }

  function capturePlanFromForm(form) {
    setSelectedPlan(sellingPlanFromForm(form), form);
  }

  // Easy Bundle adds to cart with a fetch reference it captured before this script
  // ran, so its request can't be observed. Read the plan from its purchase-option
  // UI instead: .gbbPbSubscription > selected card (ONE_TIME / SUBSCRIBE) and the
  // checked frequency radio inside its (possibly hidden) .dropdownMenu.
  function capturePlanFromBundleWidget(button) {
    var widget = button.closest(BUNDLE_WIDGET_SELECTOR) || document.querySelector(BUNDLE_WIDGET_SELECTOR);
    var purchase = widget && widget.querySelector('.gbbPbSubscription');
    if (!purchase) return;
    var selectedCard = purchase.querySelector('.gbbPbSubCard[data-selected="true"]');
    if (selectedCard && selectedCard.dataset.kind && selectedCard.dataset.kind !== 'SUBSCRIBE') {
      selectedPlan = null;
      return;
    }
    var checked = purchase.querySelector('.dropdownMenuItemInput:checked, input[name^="gbbPbSubFreq"]:checked');
    var id = checked ? String(checked.value || '').trim() : '';
    if (id) {
      setSelectedPlan(id, null);
    } else if (selectedCard) {
      selectedPlan = { id: 'bundle', name: '', frequency: BUNDLE_DEFAULT_FREQUENCY, namePromise: null };
    }
  }

  // selling_plan from an outgoing /cart/add request body: JSON ({selling_plan} or
  // {items:[{selling_plan}]}), FormData or URL-encoded (selling_plan / items[0][selling_plan]).
  function sellingPlanFromAddBody(body) {
    if (!body) return '';
    var fromJson = function(json) {
      if (!json || typeof json !== 'object') return '';
      if (json.selling_plan) return String(json.selling_plan);
      var items = Array.isArray(json.items) ? json.items : [];
      for (var i = 0; i < items.length; i++) {
        if (items[i] && items[i].selling_plan) return String(items[i].selling_plan);
      }
      return '';
    };
    var fromEntries = function(entries) {
      var found = '';
      entries.forEach(function(value, key) {
        if (found) return;
        if ((key === 'selling_plan' || /\[selling_plan\]$/.test(key)) && String(value || '').trim()) found = String(value).trim();
      });
      return found;
    };
    if (typeof body === 'string') {
      try { return fromJson(JSON.parse(body)); } catch (e) {
        try { return fromEntries(new URLSearchParams(body)); } catch (err) { return ''; }
      }
    }
    if (typeof body.forEach === 'function') return fromEntries(body);
    return fromJson(body);
  }

  // ===== Shared /cart.js snapshot =====
  // Recharge redraws its cart drawer whenever anything on the page reads /cart.js, and
  // the drawer code below re-runs on every redraw. Reading the cart on each redraw
  // looped forever (several reads a second in every open tab), so redraw-driven code
  // reads this snapshot instead, and it is only re-fetched after the cart changes:
  // a cart write seen by the fetch/XHR hooks, or a cart read by another script (how
  // Recharge refreshes after writes we can't see, such as Easy Bundle's).
  var cartSnapshot = { promise: null, stale: true };
  var ownCartRead = false;

  function markCartStale() {
    cartSnapshot.stale = true;
  }

  function requestCart() {
    var request;
    ownCartRead = true;
    try {
      request = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
    } finally {
      ownCartRead = false;
    }
    var promise = request.then(function(res) {
      if (!res.ok) throw new Error('cart.js ' + res.status);
      return res.json();
    });
    cartSnapshot = { promise: promise, stale: false };
    promise.catch(function() {
      if (cartSnapshot.promise === promise) cartSnapshot.stale = true;
    });
    return promise;
  }

  function readCart() {
    if (cartSnapshot.promise && !cartSnapshot.stale) return cartSnapshot.promise;
    return requestCart();
  }

  // Newest cart line with a selling plan (cart.js lists the most recent add first),
  // preferring the plan id captured from the form.
  function fetchCartPlan(preferredId) {
    return requestCart()
      .then(function(cart) {
        var items = (cart && cart.items) || [];
        var withPlan = items.filter(function(item) {
          return item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
        });
        var item = null;
        if (preferredId) {
          item = withPlan.filter(function(i) {
            return String(i.selling_plan_allocation.selling_plan.id) === preferredId;
          })[0];
        }
        if (!item) item = withPlan[0];
        if (!item) return null;
        var plan = item.selling_plan_allocation.selling_plan;
        return { id: String(plan.id), name: plan.name || '' };
      })
      .catch(function() { return null; });
  }

  function resolvePlan() {
    var plan = selectedPlan;
    if (plan && plan.name && !plan.namePromise) return Promise.resolve(plan);
    var pendingName = plan && plan.namePromise ? plan.namePromise : Promise.resolve(plan);
    return pendingName.then(function(current) {
      if (current && (current.name || planFrequency(current))) return current;
      var wantedId = current ? current.id : null;
      var lookup = cartPlanPromise || fetchCartPlan(wantedId);
      return lookup.then(function(cartPlan) {
        if (current) {
          if (cartPlan && cartPlan.id === current.id) current.name = cartPlan.name;
          return current;
        }
        return cartPlan;
      });
    });
  }

  function findMatchingOption(select, plan) {
    var options = Array.prototype.slice.call(select.options);
    var byId = options.filter(function(o) { return String(o.value) === String(plan.id); })[0];
    if (byId) return byId;
    if (!plan.name && !planFrequency(plan)) return null;
    var wantedName = normalizeText(plan.name);
    var byName = plan.name ? options.filter(function(o) { return normalizeText(o.text) === wantedName; })[0] : null;
    if (byName) return byName;
    var wantedKey = planFrequency(plan);
    if (!wantedKey) return null;
    return options.filter(function(o) { return frequencyKey(o.text) === wantedKey; })[0] || null;
  }

  function setLocked(select, locked) {
    var wrapper = select.closest('.aca-product-dropdown');
    select.disabled = locked;
    select.classList.toggle(LOCKED_SELECT_CLASS, locked);
    if (wrapper) wrapper.classList.toggle(LOCKED_WRAPPER_CLASS, locked);
    if (locked) {
      select.setAttribute('aria-disabled', 'true');
      select.setAttribute('title', LOCKED_TITLE);
    } else {
      select.removeAttribute('aria-disabled');
      select.removeAttribute('title');
    }
  }

  function lockSelect(select, plan) {
    var option = findMatchingOption(select, plan);
    if (!option) {
      // No equivalent frequency for this item: leave the dropdown usable.
      setLocked(select, false);
      return;
    }
    select.value = option.value;
    // EG listens for "change" to copy the plan onto the item's add button.
    select.dispatchEvent(new Event('change', { bubbles: true }));
    setLocked(select, true);
  }

  function applyToSelects(selects) {
    var pending = Array.prototype.filter.call(selects, function(select) {
      return !select.dataset.frequencyLocked;
    });
    if (!pending.length) return;

    pending.forEach(function(select) {
      select.dataset.frequencyLocked = 'pending';
      setLocked(select, true); // disabled while we confirm the plan, so nothing can be changed meanwhile
    });

    resolvePlan().then(function(plan) {
      pending.forEach(function(select) {
        if (!document.body.contains(select)) return;
        if (plan) {
          lockSelect(select, plan);
          select.dataset.frequencyLocked = 'true';
        } else {
          setLocked(select, false);
          delete select.dataset.frequencyLocked;
        }
      });
    });
  }

  function applyToModal(modal) {
    applyToSelects(modal.querySelectorAll(EG_PLAN_SELECT));
  }

  function watchForPopup() {
    var existing = document.querySelector(EG_MODAL_SELECTOR);
    if (existing) applyToModal(existing);

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (node.matches(EG_MODAL_SELECTOR)) {
            applyToModal(node);
          } else if (node.closest(EG_MODAL_SELECTOR)) {
            // EG re-renders the dropdown when the item's variant changes.
            if (node.matches(EG_PLAN_SELECT)) applyToSelects([node]);
            else applyToSelects(node.querySelectorAll(EG_PLAN_SELECT));
          } else {
            var modal = node.querySelector(EG_MODAL_SELECTOR);
            if (modal) applyToModal(modal);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Capture phase so this runs before the theme's and EG's add-to-cart handlers.
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !isAddToCartForm(form)) return;
    capturePlanFromForm(form);
  }, true);

  document.addEventListener('click', function(e) {
    var button = e.target.closest ? e.target.closest('button, input[type="submit"]') : null;
    if (!button) return;
    if (button.matches(BUNDLE_ADD_BUTTON)) {
      capturePlanFromBundleWidget(button);
      return;
    }
    if (button.type && button.type !== 'submit') return;
    var form = button.form || button.closest('form');
    if (!form || !isAddToCartForm(form)) return;
    capturePlanFromForm(form);
  }, true);

  document.addEventListener('theme:cart:added', function() {
    var wantedId = selectedPlan ? selectedPlan.id : null;
    cartPlanPromise = fetchCartPlan(wantedId).then(function(cartPlan) {
      if (selectedPlan && cartPlan && cartPlan.id === selectedPlan.id) selectedPlan.name = cartPlan.name;
      return cartPlan;
    });
  });

  if (document.body) {
    watchForPopup();
  } else {
    document.addEventListener('DOMContentLoaded', watchForPopup);
  }

  // ===== Recharge cart drawer: lock the free item's frequency =====
  // Recharge's Storefront Experiences cart (cart drawer / cart overlay) renders each line
  // with a "select[name=selling_plan]" frequency dropdown inside an open shadow root.
  // EG marks the free items it adds with a "_Gifted" line property, so those lines are
  // looked up from /cart.js and their dropdown is disabled. Recharge's own disabled
  // styles gray the control out.
  var RC_HOST_SELECTOR = '[id*="__cart-drawer"], [id*="__cart-overlay"]';
  var RC_PLAN_SELECT = 'select[name="selling_plan"]';
  var RC_LINE_SELECTOR = '.px-drawer';
  var GIFT_PROPERTY = '_Gifted';
  var RC_LOCKED_TITLE = 'The free item ships with your subscription and follows its delivery frequency';

  var rcRootsWatched = [];

  function fetchCartLines() {
    return readCart()
      .then(function(cart) {
        return ((cart && cart.items) || []).map(function(item) {
          return {
            title: String(item.product_title || '').trim(),
            gifted: !!(item.properties && item.properties[GIFT_PROPERTY])
          };
        });
      })
      .catch(function() { return null; });
  }

  function rcLineTitle(line) {
    var img = line.querySelector(':scope > div > img[alt]');
    var heading = line.querySelector('p.font-semibold');
    return String((heading && heading.textContent) || (img && img.alt) || '').trim();
  }

  // Line containers, in render order, that carry a frequency dropdown.
  function rcLines(root) {
    var lines = [];
    root.querySelectorAll(RC_PLAN_SELECT).forEach(function(select) {
      var line = select.closest(RC_LINE_SELECTOR);
      if (line && lines.indexOf(line) === -1) lines.push(line);
    });
    return lines;
  }

  function setRcLocked(select, locked) {
    if (locked) {
      select.disabled = true;
      select.setAttribute('aria-disabled', 'true');
      select.setAttribute('title', RC_LOCKED_TITLE);
      select.dataset.frequencyLocked = 'true';
    } else if (select.dataset.frequencyLocked) {
      select.disabled = false;
      select.removeAttribute('aria-disabled');
      select.removeAttribute('title');
      delete select.dataset.frequencyLocked;
    }
  }

  var RC_GIFT_CSS = '[data-gift-line] .text-right .text-xs { display: none !important; }';
  var rcGiftStyledRoots = [];
  function ensureRcGiftStyle(root) {
    if (rcGiftStyledRoots.indexOf(root) !== -1) return;
    rcGiftStyledRoots.push(root);
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(RC_GIFT_CSS);
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sheet]);
    } catch (e) {
      var style = document.createElement('style');
      style.textContent = RC_GIFT_CSS;
      root.appendChild(style);
    }
  }

  // Recharge renders a bare "0" where the compare-at price would go on a $0 line
  // ("0$0.00"). Blank that text node (React keeps the node, so this is safe) and
  // flag the line so the "Saving 10%" caption can be hidden for free items.
  function tidyGiftLine(line, gifted) {
    if (gifted) line.setAttribute('data-gift-line', '');
    else line.removeAttribute('data-gift-line');
    if (!gifted) return;
    line.querySelectorAll('.text-right').forEach(function(priceBox) {
      for (var node = priceBox.firstChild; node; node = node.nextSibling) {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() === '0') node.nodeValue = '';
      }
    });
  }

  function applyRcLocks(root) {
    ensureRcGiftStyle(root);
    if (!root.querySelector(RC_LINE_SELECTOR)) return;

    fetchCartLines().then(function(cartLines) {
      if (!cartLines) return;
      var giftTitles = cartLines.filter(function(l) { return l.gifted; }).map(function(l) { return l.title; });

      // Prefer position matching (drawer renders lines in cart order) when the drawer
      // and cart line up exactly; otherwise fall back to matching by product title.
      var allLines = Array.prototype.slice.call(root.querySelectorAll(RC_LINE_SELECTOR)).filter(function(line) {
        return line.querySelector(':scope > div > img[alt]');
      });
      var byPosition = allLines.length === cartLines.length && allLines.every(function(line, i) {
        return rcLineTitle(line) === cartLines[i].title;
      });

      allLines.forEach(function(line) {
        var gifted = byPosition
          ? cartLines[allLines.indexOf(line)].gifted
          : giftTitles.indexOf(rcLineTitle(line)) !== -1;
        tidyGiftLine(line, gifted);
        line.querySelectorAll(RC_PLAN_SELECT).forEach(function(select) {
          if (!document.contains(root.host || root)) return;
          setRcLocked(select, gifted);
        });
      });
    });
  }

  // The theme's own cart drawer is redundant once Recharge's cart is running, and it
  // shows through behind Recharge's drawer. Flag the body so custom.css hides it, and
  // close it whenever the theme opens it so it releases its scroll lock and focus trap.
  var themeDrawerWatched = false;
  function suppressThemeCartDrawer() {
    document.body.classList.add('recharge-cart-active');
    if (themeDrawerWatched) return;
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    themeDrawerWatched = true;
    var closeIfOpen = function() {
      if (!drawer.classList.contains('is-open')) return;
      setTimeout(function() {
        if (typeof drawer.closeCartDrawer === 'function') drawer.closeCartDrawer();
      }, 0);
    };
    new MutationObserver(closeIfOpen).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    closeIfOpen();
  }

  function watchRcRoot(root) {
    if (rcRootsWatched.indexOf(root) !== -1) return;
    rcRootsWatched.push(root);
    suppressThemeCartDrawer();

    var timer = null;
    var schedule = function() {
      clearTimeout(timer);
      timer = setTimeout(function() {
        applyRcLocks(root);
        renderCartFrequencyPanel(root);
      }, 150);
    };

    var insideOwnPanel = function(node) {
      var el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
      return !!(el && el.closest && el.closest('#' + CFP_ID));
    };

    new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          // Recharge re-enables the select after its own pending state; re-lock it.
          var el = m.target;
          if (el.dataset && el.dataset.frequencyLocked && !el.disabled) el.disabled = true;
        } else if (m.addedNodes.length) {
          var foreign = false;
          for (var j = 0; j < m.addedNodes.length; j++) {
            if (!insideOwnPanel(m.addedNodes[j])) { foreign = true; break; }
          }
          if (foreign && !insideOwnPanel(m.target)) schedule();
        }
      }
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });

    schedule();
  }

  // The host div is inserted before Recharge attaches its shadow root, so poll briefly.
  function watchRcHost(host, attempts) {
    if (host.shadowRoot) {
      watchRcRoot(host.shadowRoot);
      return;
    }
    if (attempts > 40) return;
    setTimeout(function() { watchRcHost(host, attempts + 1); }, 250);
  }

  function scanForRcHosts(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches(RC_HOST_SELECTOR)) watchRcHost(scope, 0);
    scope.querySelectorAll(RC_HOST_SELECTOR).forEach(function(host) { watchRcHost(host, 0); });
  }

  function watchForRechargeCart() {
    scanForRcHosts(document.body);
    new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === Node.ELEMENT_NODE) scanForRcHosts(added[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('theme:cart:added', function() {
    markCartStale();
    rcRootsWatched.forEach(function(root) {
      setTimeout(function() {
        applyRcLocks(root);
        renderCartFrequencyPanel(root);
      }, 300);
    });
  });

  if (document.body) {
    watchForRechargeCart();
  } else {
    document.addEventListener('DOMContentLoaded', watchForRechargeCart);
  }


  // ===== Keep free items on the subscription's frequency =====
  // Whenever the cart changes (Recharge drawer, cart page, theme drawer), every EG gift
  // line is moved to the selling plan whose name matches the paid subscription's plan.
  // Gift products have their own plan ids, so the id is looked up from the product's
  // JSON by plan name. Changes go through /cart/change.js, which Recharge watches, so
  // its drawer redraws by itself; the theme's drawer is told to refresh explicitly.
  var CART_WRITE_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var CART_CHANGE_RE = /\/cart\/change(\.js|\.json)?(\?|$)/;
  var syncTimer = null;
  var syncRunning = false;
  var syncQueued = false;
  var bulkApplyRunning = false; // the cart-wide panel is rewriting lines; hold the gift sync
  var internalCartWrite = false;
  var lastPlanChange = null; // { id, line, time } from the most recent external selling_plan change

  function cartRequestPath(input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    try { return new URL(url, window.location.origin).pathname; } catch (e) { return String(url).split('?')[0]; }
  }

  function bodyField(body, field) {
    if (!body) return null;
    if (typeof body === 'string') {
      try {
        var json = JSON.parse(body);
        return Object.prototype.hasOwnProperty.call(json, field) ? json[field] : null;
      } catch (e) {
        try { return new URLSearchParams(body).get(field); } catch (err) { return null; }
      }
    }
    if (typeof body.get === 'function') return body.get(field);
    return Object.prototype.hasOwnProperty.call(body, field) ? body[field] : null;
  }

  function recordPlanChange(body) {
    var sellingPlan = bodyField(body, 'selling_plan');
    if (sellingPlan === null || sellingPlan === undefined) return;
    lastPlanChange = { id: bodyField(body, 'id'), line: bodyField(body, 'line'), time: Date.now() };
  }

  function scheduleGiftSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncGiftFrequencies, delay == null ? 300 : delay);
  }

  function planOf(item) {
    return item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
  }

  function isGiftLine(item) {
    return !!(item.properties && item.properties[GIFT_PROPERTY]);
  }

  // The paid subscription line whose frequency the gifts should follow: the line the
  // customer just changed when we saw it, otherwise the most recently added one.
  function targetSubscriptionLine(items) {
    var paid = items.filter(function(item) { return planOf(item) && !isGiftLine(item); });
    if (!paid.length) return null;
    if (lastPlanChange && Date.now() - lastPlanChange.time < 15000) {
      var wanted = lastPlanChange.id != null ? String(lastPlanChange.id) : null;
      var byId = wanted && paid.filter(function(item) {
        return item.key === wanted || String(item.variant_id) === wanted || String(item.id) === wanted;
      })[0];
      if (byId) return byId;
      var line = parseInt(lastPlanChange.line, 10);
      if (line > 0 && items[line - 1] && paid.indexOf(items[line - 1]) !== -1) return items[line - 1];
    }
    return paid[0];
  }

  function matchingPlanId(plans, targetPlan) {
    var wantedName = normalizeText(targetPlan.name);
    var wantedKey = planFrequency(targetPlan);
    var byKey = null;
    for (var id in plans) {
      if (!Object.prototype.hasOwnProperty.call(plans, id)) continue;
      if (wantedName && normalizeText(plans[id].name) === wantedName) return id;
      if (!byKey && wantedKey && plans[id].frequency === wantedKey) byKey = id;
    }
    return byKey;
  }

  function sameFrequency(planA, planB) {
    var keyA = planFrequency(planA);
    var keyB = planFrequency(planB);
    if (keyA && keyB) return keyA === keyB;
    return normalizeText(planA.name) === normalizeText(planB.name);
  }

  // EG wraps fetch and XHR, and treats any change to a gifted line as buying the gift
  // outside its rule (it shows the "limited promotion" alert). Gift-line writes go
  // through a pristine fetch taken from a hidden same-origin iframe instead, which
  // none of the app wrappers see. Recharge still redraws, because the cart is
  // re-read through the wrapped fetch right afterwards.
  var pristineFetch = null;
  function unwrappedFetch() {
    if (pristineFetch) return pristineFetch;
    try {
      var frame = document.getElementById('cart-fetch-frame');
      if (!frame) {
        frame = document.createElement('iframe');
        frame.id = 'cart-fetch-frame';
        frame.setAttribute('aria-hidden', 'true');
        frame.tabIndex = -1;
        frame.style.display = 'none';
        frame.src = 'about:blank';
        document.body.appendChild(frame);
      }
      var frameFetch = frame.contentWindow && frame.contentWindow.fetch;
      if (typeof frameFetch === 'function') pristineFetch = frameFetch.bind(frame.contentWindow);
    } catch (e) { pristineFetch = null; }
    return pristineFetch || window.fetch.bind(window);
  }

  function changeLinePlan(item, planId) {
    internalCartWrite = true;
    var doFetch = isGiftLine(item) ? unwrappedFetch() : window.fetch.bind(window);
    return doFetch(window.location.origin + '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: item.quantity, selling_plan: planId })
    }).then(function(res) {
      internalCartWrite = false;
      markCartStale(); // the iframe fetch for gift lines bypasses the fetch hook
      return res.ok;
    }, function() {
      internalCartWrite = false;
      markCartStale();
      return false;
    });
  }

  function syncGiftFrequencies() {
    if (syncRunning || bulkApplyRunning) {
      syncQueued = true;
      return;
    }
    syncRunning = true;

    requestCart()
      .then(function(cart) {
        var items = (cart && cart.items) || [];
        var target = targetSubscriptionLine(items);
        if (!target) return false;
        var targetPlan = planOf(target);
        var stale = items.filter(function(item) {
          var plan = planOf(item);
          return isGiftLine(item) && plan && !sameFrequency(plan, targetPlan);
        });

        // One change at a time: Shopify's cart endpoints don't like concurrent writes.
        return stale.reduce(function(chain, item) {
          return chain.then(function(changed) {
            return fetchProductPlans(item.handle).then(function(plans) {
              var planId = matchingPlanId(plans, targetPlan);
              if (!planId || String(planOf(item).id) === planId) return changed;
              return changeLinePlan(item, planId).then(function(ok) { return changed || ok; });
            });
          });
        }, Promise.resolve(false));
      })
      .catch(function() { return false; })
      .then(function(changed) {
        syncRunning = false;
        if (changed) {
          markCartStale();
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          rcRootsWatched.forEach(function(root) { applyRcLocks(root); });
        }
        if (syncQueued) {
          syncQueued = false;
          scheduleGiftSync(200);
        }
      });
  }


  // ===== Cart-wide subscription control in the Recharge cart drawer =====
  // Replaces Recharge's per-line "Deliver every" dropdowns with one panel above the
  // subtotal: a Subscribe / One-time toggle and a frequency selector applied to every
  // line that can subscribe. Controlled by the theme settings "Enable cart-wide
  // subscription control" and "Heading" (window.theme.settings.cartFrequency*).
  var CFP_ID = 'cart-frequency-panel';
  var CFP_HIDDEN_ATTR = 'data-cart-frequency-hidden';
  var CFP_UNIT_ORDER = { day: 0, week: 1, month: 2, year: 3 };
  var CFP_CSS =
    '[' + CFP_HIDDEN_ATTR + '] { display: none !important; }' +
    '#' + CFP_ID + ' { padding-bottom: 16px; margin-bottom: 12px; border-bottom: 1px solid rgba(0,0,0,0.12); }' +
    '#' + CFP_ID + '[aria-busy="true"] { opacity: 0.6; pointer-events: none; }' +
    '#' + CFP_ID + ' .cfp-heading { font-weight: 700; font-size: 15px; margin: 0 0 10px; }' +
    '#' + CFP_ID + ' .cfp-row { display: flex; gap: 10px; align-items: stretch; flex-wrap: wrap; }' +
    '#' + CFP_ID + ' .cfp-toggle { display: inline-flex; border: 1px solid currentColor; border-radius: 999px; padding: 2px; flex: 0 0 auto; }' +
    '#' + CFP_ID + ' .cfp-toggle label { position: relative; padding: 6px 14px; border-radius: 999px; font-size: 13px; cursor: pointer; line-height: 1.3; white-space: nowrap; }' +
    '#' + CFP_ID + ' .cfp-toggle label.is-active { background: currentColor; }' +
    '#' + CFP_ID + ' .cfp-toggle label.is-active span { color: #fff; mix-blend-mode: difference; }' +
    '#' + CFP_ID + ' .cfp-toggle input { position: absolute; opacity: 0; width: 1px; height: 1px; margin: 0; }' +
    '#' + CFP_ID + ' .cfp-toggle input:focus-visible + span { outline: 2px solid currentColor; outline-offset: 3px; border-radius: 999px; }' +
    '#' + CFP_ID + ' .cfp-frequency { flex: 1 1 140px; min-width: 140px; font: inherit; font-size: 13px; padding: 6px 32px 6px 10px; border: 1px solid rgba(0,0,0,0.25); border-radius: 8px; background: transparent; color: inherit; appearance: none; -webkit-appearance: none; background-image: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'8\' viewBox=\'0 0 12 8\'><path d=\'M1 1l5 5 5-5\' fill=\'none\' stroke=\'%23333\' stroke-width=\'1.5\'/></svg>"); background-repeat: no-repeat; background-position: right 10px center; }' +
    '#' + CFP_ID + ' .cfp-frequency:disabled { opacity: 0.45; }' +
    '#' + CFP_ID + ' .cfp-note { margin: 8px 0 0; font-size: 12px; opacity: 0.8; }' +
    '#' + CFP_ID + ' .cfp-note a { color: inherit; text-decoration: underline; }' +
    '#' + CFP_ID + ' .cfp-note[hidden] { display: none; }';

  var cfpBusy = false;
  var cfpPendingNote = '';
  var cfpStyledRoots = [];

  function cfpEnabled() {
    var settings = window.theme && window.theme.settings;
    return !!(settings && settings.cartFrequencyControl);
  }

  function cfpHeading() {
    var settings = window.theme && window.theme.settings;
    return (settings && settings.cartFrequencyHeading) || 'Subscribe & Save';
  }

  function frequencyLabel(key) {
    var parts = String(key).split(' ');
    var count = parseInt(parts[0], 10);
    var unit = parts[1] || '';
    return count === 1 ? 'Every ' + unit : 'Every ' + count + ' ' + unit + 's';
  }

  function sortFrequencyKeys(keys) {
    return keys.sort(function(a, b) {
      var pa = a.split(' '), pb = b.split(' ');
      var ua = CFP_UNIT_ORDER[pa[1]] || 0, ub = CFP_UNIT_ORDER[pb[1]] || 0;
      return ua !== ub ? ua - ub : parseInt(pa[0], 10) - parseInt(pb[0], 10);
    });
  }

  function unique(list) {
    return list.filter(function(value, index) { return value && list.indexOf(value) === index; });
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // A one-time Easy Bundle sits in the cart as one parent line for a product with no
  // selling plans; the subscription version is added by the bundle app as child lines.
  function isBundleParentLine(item) {
    var props = item.properties || {};
    return !!(props._EasyBundleId || props['_easyBundle:OfferId']);
  }

  // What the cart looks like for the panel: per line, which frequencies its product
  // offers and which one it is on; overall mode, dominant frequency, and whether the
  // lines disagree with each other.
  function cartFrequencyState() {
    return readCart()
      .then(function(cart) {
        var items = (cart && cart.items) || [];
        var handles = unique(items.map(function(item) { return item.handle; }));
        return Promise.all(handles.map(fetchProductPlans)).then(function(planSets) {
          var plansByHandle = {};
          handles.forEach(function(handle, i) { plansByHandle[handle] = planSets[i] || {}; });

          var lines = items.map(function(item) {
            var plans = plansByHandle[item.handle] || {};
            var available = {};
            Object.keys(plans).forEach(function(id) {
              var key = plans[id].frequency;
              if (key && !available[key]) available[key] = id;
            });
            var current = planOf(item);
            return {
              item: item,
              available: available,
              eligible: Object.keys(available).length > 0,
              bundleParent: Object.keys(available).length === 0 && isBundleParentLine(item),
              current: current ? planFrequency(current) : null
            };
          });

          var eligible = lines.filter(function(line) { return line.eligible; });
          var bundleParents = lines.filter(function(line) { return line.bundleParent; });
          var options = sortFrequencyKeys(unique([].concat.apply([], eligible.map(function(line) { return Object.keys(line.available); }))));
          if (!options.length && bundleParents.length) options = [BUNDLE_DEFAULT_FREQUENCY];
          var subscribed = eligible.filter(function(line) { return line.current; });
          var counts = {};
          subscribed.forEach(function(line) { counts[line.current] = (counts[line.current] || 0) + 1; });
          var dominant = null;
          Object.keys(counts).forEach(function(key) {
            if (dominant === null || counts[key] > counts[dominant]) dominant = key;
          });

          return {
            lines: lines,
            eligible: eligible.length > 0 || bundleParents.length > 0,
            bundleParents: bundleParents,
            options: options,
            mode: subscribed.length ? 'subscribe' : 'onetime',
            frequency: dominant || options[0] || null,
            mixed: subscribed.length > 0 && (Object.keys(counts).length > 1 || subscribed.length < eligible.length)
          };
        });
      })
      .catch(function() { return null; });
  }

  function applyCartFrequency(root, mode, frequency) {
    if (cfpBusy) return Promise.resolve();
    cfpBusy = true;
    bulkApplyRunning = true;
    var panel = root.getElementById(CFP_ID);
    if (panel) panel.setAttribute('aria-busy', 'true');

    markCartStale(); // the lines are rewritten from this state, so read it fresh
    return cartFrequencyState().then(function(state) {
      if (!state) return null;
      if (mode === 'subscribe' && (!frequency || state.options.indexOf(frequency) === -1)) frequency = state.options[0];
      var changes = state.lines.filter(function(line) {
        if (!line.eligible) return false;
        if (mode === 'onetime') return !!line.current;
        return line.current !== frequency && !!line.available[frequency];
      });
      return changes.reduce(function(chain, line) {
        return chain.then(function() {
          return changeLinePlan(line.item, mode === 'onetime' ? null : line.available[frequency]);
        });
      }, Promise.resolve()).then(function() {
        var notes = [];
        if (state.mixed || changes.length) {
          notes.push(mode === 'onetime'
            ? 'All items set to one-time purchase.'
            : 'All items set to ' + frequencyLabel(frequency).toLowerCase() + '.');
        }
        if (mode === 'subscribe' && state.bundleParents.length) {
          var links = state.bundleParents.map(function(line) {
            var href = '/products/' + encodeURIComponent(line.item.handle || '');
            return '<a href="' + href + '">' + escapeHtml(line.item.product_title || 'bundle') + '</a>';
          });
          notes.push('Bundles switch to a subscription from the bundle page: ' + links.join(', ') + '.');
        }
        cfpPendingNote = notes.join(' ');
        return state;
      });
    }).then(function() { finishApply(); }, function() { finishApply(); });

    function finishApply() {
      cfpBusy = false;
      bulkApplyRunning = false;
      markCartStale();
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      scheduleGiftSync(200);
      renderCartFrequencyPanel(root);
    }
  }

  function ensureCfpStyle(root) {
    if (cfpStyledRoots.indexOf(root) !== -1) return;
    cfpStyledRoots.push(root);
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(CFP_CSS);
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sheet]);
    } catch (e) {
      var style = document.createElement('style');
      style.textContent = CFP_CSS;
      root.appendChild(style);
    }
  }

  function buildCfpPanel(root) {
    var panel = document.createElement('div');
    panel.id = CFP_ID;
    panel.className = 'px-drawer';
    panel.innerHTML =
      '<p class="cfp-heading"></p>' +
      '<div class="cfp-row">' +
        '<div class="cfp-toggle" role="radiogroup" aria-label="Purchase type">' +
          '<label><input type="radio" name="cfp-mode" value="subscribe"><span>Subscribe</span></label>' +
          '<label><input type="radio" name="cfp-mode" value="onetime"><span>One-time</span></label>' +
        '</div>' +
        '<select class="cfp-frequency" aria-label="Delivery frequency"></select>' +
      '</div>' +
      '<p class="cfp-note" role="status" hidden></p>';

    panel.addEventListener('change', function(e) {
      var select = panel.querySelector('.cfp-frequency');
      if (e.target.name === 'cfp-mode') {
        applyCartFrequency(root, e.target.value, select.value);
      } else if (e.target === select) {
        var subscribe = panel.querySelector('input[value="subscribe"]');
        subscribe.checked = true;
        applyCartFrequency(root, 'subscribe', select.value);
      }
    });
    return panel;
  }

  function updateCfpPanel(panel, state) {
    panel.querySelector('.cfp-heading').textContent = cfpHeading();

    var select = panel.querySelector('.cfp-frequency');
    var signature = state.options.join('|');
    if (select.dataset.options !== signature) {
      select.innerHTML = '';
      state.options.forEach(function(key) {
        var option = document.createElement('option');
        option.value = key;
        option.textContent = frequencyLabel(key);
        select.appendChild(option);
      });
      select.dataset.options = signature;
    }
    if (state.frequency) select.value = state.frequency;
    select.disabled = state.mode !== 'subscribe';

    panel.querySelectorAll('input[name="cfp-mode"]').forEach(function(input) {
      input.checked = input.value === state.mode;
      input.closest('label').classList.toggle('is-active', input.checked);
    });

    var note = panel.querySelector('.cfp-note');
    if (cfpPendingNote) {
      note.innerHTML = cfpPendingNote;
      note.hidden = false;
      cfpPendingNote = '';
    }
    panel.removeAttribute('aria-busy');
  }

  function hideLineFrequencySelects(root) {
    root.querySelectorAll(RC_PLAN_SELECT).forEach(function(select) {
      var wrapper = select.closest('.space-y-1') || select.parentElement;
      if (wrapper) wrapper.setAttribute(CFP_HIDDEN_ATTR, '');
    });
    // Recharge's per-line "Upgrade to subscription" button is another per-item control.
    root.querySelectorAll('.px-drawer button').forEach(function(button) {
      if (/upgrade to subscription/i.test(button.textContent)) button.setAttribute(CFP_HIDDEN_ATTR, '');
    });
  }

  function renderCartFrequencyPanel(root) {
    var existing = root.getElementById(CFP_ID);
    if (!cfpEnabled()) {
      if (existing) existing.remove();
      return;
    }
    var footer = root.querySelector('footer');
    if (!footer) {
      if (existing) existing.remove();
      return;
    }
    ensureCfpStyle(root);
    hideLineFrequencySelects(root);

    cartFrequencyState().then(function(state) {
      if (cfpBusy) return; // an apply is in flight; it re-renders when done
      var panel = root.getElementById(CFP_ID);
      if (!state || !state.eligible) {
        if (panel) panel.remove();
        return;
      }
      var currentFooter = root.querySelector('footer');
      if (!currentFooter) return;
      if (!panel || panel.parentNode !== currentFooter) {
        if (panel) panel.remove();
        panel = buildCfpPanel(root);
        currentFooter.insertBefore(panel, currentFooter.firstChild);
      }
      updateCfpPanel(panel, state);
    });
  }


  var CART_READ_RE = /\/cart(\.js|\.json)$/;

  // Watch every cart write on the page (theme, Recharge drawer, EG) via fetch.
  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch;
    window.fetch = function(input, init) {
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'GET' && !ownCartRead && CART_READ_RE.test(cartRequestPath(input))) {
        // Another script re-reading the cart usually means it changed in a way we
        // didn't see; let the next drawer redraw fetch it again.
        markCartStale();
      }
      var path = method === 'POST' ? cartRequestPath(input) : '';
      var isCartWrite = !!path && CART_WRITE_RE.test(path);
      if (isCartWrite) markCartStale();
      if (isCartWrite && !internalCartWrite && CART_CHANGE_RE.test(path)) {
        recordPlanChange(init && init.body);
      }
      if (isCartWrite && /\/cart\/add/.test(path)) {
        // Bundle builders and quick views add via fetch rather than the product form.
        var addedPlan = sellingPlanFromAddBody(init && init.body);
        if (addedPlan) setSelectedPlan(addedPlan, null);
      }
      var result = nativeFetch.apply(this, arguments);
      if (isCartWrite) {
        result.then(function(res) {
          markCartStale();
          if (res && res.ok) scheduleGiftSync();
        }, markCartStale);
      }
      return result;
    };
  }

  // Some apps write the cart over XHR; keep the snapshot honest for those too.
  if (window.XMLHttpRequest) {
    var xhrOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      if (String(method || '').toUpperCase() === 'POST' && CART_WRITE_RE.test(cartRequestPath(String(url || '')))) {
        markCartStale();
        this.addEventListener('loadend', markCartStale);
      }
      return xhrOpen.apply(this, arguments);
    };
  }

  document.addEventListener('theme:cart:added', function() { scheduleGiftSync(); });
  window.addEventListener('load', function() { scheduleGiftSync(1500); });




  // ===== Dinner Dash variety box: the meat picker routes to a single-cut bundle =====
  // The variety box lists three cuts as variants, but each cut is also sold as its own
  // bundle product. Picking a cut therefore navigates to that product rather than
  // selecting a variant: the dropdown opens on a "Select one" placeholder and the
  // submit button stays disabled reading "Next Step", so the page reads as a chooser.
  // The layout that goes with this lives in custom.css.
  var MEAT_PICKER_HANDLE = 'the-dinner-dash-bundle-20-lb-beef-variety-box';
  var MEAT_PICKER_PLACEHOLDER = 'Select one';
  var MEAT_PICKER_SUBMIT_TEXT = 'Next Step';

  // Matched against the option value, so rewording "20 lbs Stew Meat" keeps working.
  var MEAT_PICKER_ROUTES = [
    { keyword: 'ground', url: '/products/the-dinner-dash-bundle-20-lbs-ground-beef' },
    { keyword: 'stew', url: '/products/the-dinner-dash-bundle-20-lbs-stew-meat' },
    { keyword: 'fajita', url: '/products/the-dinner-dash-bundle-20-lbs-fajita-meat' }
  ];

  function meatPickerRoute(value) {
    var needle = String(value || '').toLowerCase();
    for (var i = 0; i < MEAT_PICKER_ROUTES.length; i++) {
      if (needle.indexOf(MEAT_PICKER_ROUTES[i].keyword) !== -1) {
        return MEAT_PICKER_ROUTES[i].url;
      }
    }
    return null;
  }

  // Keeps a node's text pinned to value; the theme rewrites both the popout label and
  // the submit label when it initialises the product form, which can land after us.
  function meatPickerPinText(node, value, extra) {
    if (node.textContent.trim() !== value) node.textContent = value;
    new MutationObserver(function() {
      if (node.textContent.trim() !== value) node.textContent = value;
      if (extra) extra();
    }).observe(node, { childList: true, characterData: true, subtree: true });
  }

  function meatPickerPlaceholderItem() {
    var item = document.createElement('li');
    item.className = 'select-popout__item select-popout__item--current select-popout__item--placeholder';

    // Deliberately no data-popout-option: the theme must not treat the placeholder
    // as a real option value.
    var option = document.createElement('a');
    option.className = 'select-popout__option';
    option.href = '#';
    option.setAttribute('aria-current', 'true');

    var text = document.createElement('span');
    text.textContent = MEAT_PICKER_PLACEHOLDER;
    option.appendChild(text);
    item.appendChild(option);
    return item;
  }

  function setUpMeatPickerDropdown() {
    var picker = document.querySelector('.product__form .product__selectors .select-popout');
    if (!picker || picker.hasAttribute('data-meat-picker')) return;
    picker.setAttribute('data-meat-picker', '');

    var list = picker.querySelector('[data-popout-list] .select-popout__list__scroll');
    if (list && !list.querySelector('.select-popout__item--placeholder')) {
      // Nothing has been chosen yet, so drop the preselected first variant's marker.
      var current = list.querySelector('.select-popout__item--current');
      if (current) current.classList.remove('select-popout__item--current');

      var currentOption = list.querySelector('[aria-current="true"]');
      if (currentOption) currentOption.removeAttribute('aria-current');

      list.insertBefore(meatPickerPlaceholderItem(), list.firstChild);
    }

    var label = picker.querySelector('[data-popout-text]');
    if (label) meatPickerPinText(label, MEAT_PICKER_PLACEHOLDER);
  }

  function setUpMeatPickerSubmit() {
    var button = document.querySelector('.product__form [data-add-to-cart]');
    if (!button || button.hasAttribute('data-meat-picker-submit')) return;
    button.setAttribute('data-meat-picker-submit', '');

    function disable() {
      if (!button.hasAttribute('disabled')) button.setAttribute('disabled', 'disabled');
    }
    disable();

    var label = button.querySelector('[data-add-to-cart-text]');
    if (label) meatPickerPinText(label, MEAT_PICKER_SUBMIT_TEXT, disable);

    new MutationObserver(disable).observe(button, {
      attributes: true,
      attributeFilter: ['disabled']
    });
  }

  if (document.body.id === MEAT_PICKER_HANDLE) {
    // Capture phase, delegated from the document: the theme owns the popout's own
    // click handling and may re-render the selectors, so this has to run first and
    // survive a replaced picker.
    document.addEventListener('click', function(event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var option = target.closest('.product__form .select-popout__option');
      if (!option) return;

      event.preventDefault();
      event.stopPropagation();

      var url = meatPickerRoute(option.getAttribute('data-value') || option.textContent);
      if (url) {
        window.location.href = url;
        return;
      }

      // The placeholder: close the dropdown and leave the selection alone.
      var picker = option.closest('.select-popout');
      var toggle = picker && picker.querySelector('[data-popout-toggle]');
      if (toggle && toggle.getAttribute('aria-expanded') === 'true') toggle.click();
    }, true);

    var setUpMeatPicker = function() {
      setUpMeatPickerDropdown();
      setUpMeatPickerSubmit();
    };

    setUpMeatPicker();
    document.addEventListener('DOMContentLoaded', setUpMeatPicker);
    window.addEventListener('load', setUpMeatPicker);
  }


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
